import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router, Event } from '@angular/router';
import { NotificationsService } from './core/services/notifications.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'HRIM';
  constructor(private router: Router, private notificationsService: NotificationsService) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.notificationsService.clearNotifications();
      }
    });
  }
  ngOnInit(): void {

  }
}
